const ARABIAN = "ar";
const CHINESE = "zh-CN";
const ENGLISH = "en";
const GERMAN = "de";
const ITALIAN = "it";
const RUSSIAN = "ru";
const SPANISH = "es";
const JAPANESE = "ja";
const PORTUGUESE = "pt";
const FRENCH = "fr";

const supported = [ARABIAN, CHINESE, ENGLISH, GERMAN, ITALIAN, RUSSIAN, SPANISH, JAPANESE, PORTUGUESE, FRENCH];
const fallback = ITALIAN;

const options = [
    [ARABIAN, "عربى"],
    [GERMAN, "Deutsche"],
    [ENGLISH, "English"],
    [SPANISH, "Español"],
    [FRENCH, "Français"],
    [ITALIAN, "Italiano"],
    [JAPANESE, "日本人"],
    [PORTUGUESE, "Português"],
    [RUSSIAN, "русский"],
    [CHINESE, "中文"],
];

const locales = {
    supported,
    fallback,
    options,
    ARABIAN,
    CHINESE,
    ENGLISH,
    GERMAN,
    ITALIAN,
    RUSSIAN,
    SPANISH,
    JAPANESE,
    PORTUGUESE,
    FRENCH,
};
export default locales;
